import { LookupAction } from '@rx/http'

export class ProjectPowerLookups {
    static powerTypes: LookupAction = {
        controllerName: "projectpower",
        actionName: "powerTypes",
		cacheOption: {
            isVersionBase: true,
            tableName:''
        }
    };

}



// WEBPACK FOOTER //
// ./src/app/lookups/project-power-lookups.ts